<template>
    <div class='next-page d-flex align-items-center'>
        <img src="/icons/down.png" @click="submit">
        <p>{{ text }}</p>
    </div>
</template>

<script>
export default {
    name: 'next-page',
    props: ["text"],

    methods: {
        submit() {
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
    .next-page {
        IMG {height: 80px; cursor: pointer;}
        P {margin-left: 10px; margin-bottom: 0}
        @media (max-width: 767.98px) { 
            IMG {height: 60px}
        }
    }

    
</style>